/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { RootState } from "@redux/rootReducer";
import { fetchContractVendors, fetchPurchaseInfo } from "@redux/warehouseSlice";
import { Button, Row, Tabs } from "antd";
import { PurchaseStatus } from "@api/utils/normalizeWarehouse";
import { useDispatch, useSelector } from "react-redux";
import useIntRouteParam from "@hooks/useIntRouteParam";
import styled from "styled-components";
import PageTitle from "@component/PageTitle";
import IntoWarehouseForm from "./IntoWarehouseForm";
import WarehouseInfo from "./WarehouseInfo";
import WarehouseProduct from "./WarehouseProduct";

const Wrapper = styled.div`
  padding: 17px 20px 17px 25px;
`;

const InfoWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  padding: 8px 20px 8px 12px;
  position: relative;
`;

const ButtonRow = styled(Row)`
  position: absolute;
  right: 20px;
  top: 9px;
`;

const CustomButton = styled(Button)`
  margin-right: 10px;
`;

const warehouseSlice = (state: RootState) => state.warehouseSlice;

export default function IntoWarehouseEdit() {
  const warehouseId = useIntRouteParam("warehouseId", true);
  const dispatch = useDispatch();
  const { purchaseInfo } = useSelector(warehouseSlice);

  const [activeKey, setActiveKey] = useState<string>("edit");
  const [openForm, setOpenForm] = useState<boolean>(false);

  useEffect(() => {
    dispatch(fetchPurchaseInfo({ purchaseId: warehouseId }));
  }, [dispatch, warehouseId]);

  useEffect(() => {
    dispatch(fetchContractVendors());
  }, [dispatch]);

  return (
    <Wrapper>
      <PageTitle title={`進倉 - ${purchaseInfo?.stoNumber}`} />
      <InfoWrapper>
        <Tabs type="card" onChange={(key) => setActiveKey(key)}>
          <Tabs.TabPane tab="編輯進倉單" key="edit">
            <WarehouseInfo purchase={purchaseInfo} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="進倉商品" key="product">
            <WarehouseProduct />
          </Tabs.TabPane>
        </Tabs>
        {activeKey === "edit" && (
          <ButtonRow align="middle">
            <CustomButton disabled>
              列印麥頭
            </CustomButton>
            {/* D202400301__[Urmart] 進倉後台介面優化 部分功能隱藏 */}
            {/* <Button
              type="primary"
              disabled={
                !!purchaseInfo?.destroyedAt ||
                purchaseInfo?.status === PurchaseStatus.DEPLOY_SUCCESS ||
                purchaseInfo?.status === PurchaseStatus.FINISH
              }
              onClick={() => setOpenForm(true)}
            >
              編輯
            </Button> */}
          </ButtonRow>
        )}
        {openForm && <IntoWarehouseForm purchaseId={warehouseId} close={() => setOpenForm(false)} />}
      </InfoWrapper>
    </Wrapper>
  );
}
